import { useMemo } from 'react';

// Custom hook for dynamic achievement colors with caching
export const useAchievementColors = (achievementsTypes = []) => {
    return useMemo(() => {
        const colorMap = {};

        achievementsTypes.forEach(type => {
            colorMap[type.achievement_type] = {
                bgcolor: type.bgcolor || '#14b8a6',
                color: type.color || '#ffffff',
                icon: type.icon || ''
            };
        });

        // Fallback colors for backward compatibility and when no dynamic data is available
        const fallbackColors = {
            'easy': { bgcolor: '#14b8a6', color: '#ffffff' },
            'medium': { bgcolor: '#FF9800', color: '#ffffff' },
            'hard': { bgcolor: '#6366f1', color: '#ffffff' },
            'legendary': { bgcolor: '#1a242d', color: '#ffffff' }
        };

        return (achievement_type) => {
            // First try to get from dynamic data
            if (colorMap[achievement_type]) {
                return colorMap[achievement_type];
            }

            // Fallback to static colors
            if (fallbackColors[achievement_type]) {
                return fallbackColors[achievement_type];
            }

            // Default fallback
            return fallbackColors['easy'];
        };
    }, [achievementsTypes]);
};

// Function to convert hex color to pastel
export function getPastelColor(hexColor, opacity = 0.3) {
    // Remove # if present
    const hex = hexColor.replace('#', '');

    // Parse RGB values
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Convert to pastel by mixing with white
    const pastelR = Math.round(r + (255 - r) * opacity);
    const pastelG = Math.round(g + (255 - g) * opacity);
    const pastelB = Math.round(b + (255 - b) * opacity);

    // Convert back to hex
    return `#${pastelR.toString(16).padStart(2, '0')}${pastelG.toString(16).padStart(2, '0')}${pastelB.toString(16).padStart(2, '0')}`;
} 